
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'

export default Vue.extend({
  data: () => ({
    counties: [
      'Baranya',
      'Bács-Kiskun',
      'Békés',
      'Borsod-Abaúj-Zemplén',
      'Csongrád-Csanád',
      'Fejér',
      'Győr-Moson-Sopron',
      'Hajdú-Bihar',
      'Heves',
      'Jász-Nagykun-Szolnok',
      'Komárom-Esztergom',
      'Nógrád',
      'Pest',
      'Somogy',
      'Szabolcs-Szatmár-Bereg',
      'Tolna',
      'Vas',
      'Veszprém',
      'Zala'
    ]
  }),

  computed: {
    ...mapFields([
      'requester.name',
      'requester.county',
      'requester.city',
      'requester.address',
      'requester.email',
      'requester.phone',
      'requester.rules',
      'formValidity.requesterForm'
    ])
  },

  methods: {
    submit () {
      if ((this as any).$refs.form.validate()) {//eslint-disable-line
        this.$emit('moveToNext')
      }
    }
  }
})
